import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KPIComponent } from '../landing-page/KPI/kpi.component';
import { ScheduleComponent } from '../landing-page/schedule/schedule.component';
import { LandingClientService } from 'src/app/common/services/landing-page.client';
import { StorageService } from 'src/app/common/services/storage.service';

@Component({
  selector: 'app-tile',
  standalone: true,
  imports: [CommonModule, KPIComponent, ScheduleComponent],
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss']
})
export class TileComponent implements OnInit {
  isDOR = false;
  loaded = false;
  refreshing = false;
  lastRefreshed = '';

  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.landingClientService.getJobTitleDetails().subscribe((userTitleDetails) => {
      const user = JSON.parse(this.storageService.getUser() ?? '{}');
      this.isDOR = (userTitleDetails && userTitleDetails.isDOR) || user.issuperuser === true;
      this.lastRefreshed = new Date().toLocaleTimeString();
      this.loaded = true;
    });
  }

  refresh(): void {
    this.refreshing = true;
    setTimeout(() => {
      this.refreshing = false;
      this.lastRefreshed = new Date().toLocaleTimeString();
    });
  }
}
